module.exports = __webpack_public_path__ + "static/img/icon-external-link-grey.19cd4e7.png";